import React from 'react';
import {useDispatch} from 'react-redux';
import {openCollegeTaggingModal} from 'shared/college-profile/actions/college-profile';

import Button from 'src/components/button';

const CollegeTaggingCard = () => {
  const dispatch = useDispatch();

  const renderButton = (className) => (
    <Button
      onClick={() => dispatch(openCollegeTaggingModal())}
      className={className}
      color="gray"
      width={100}
      outline
    >
      Tag
    </Button>
  );

  return (
    <div
      className="shared-card college-profile-right-rail-college-tagging-card"
      data-testid="college-tagging-card"
    >
      Tag colleges you follow with what&rsquo;s important to you.
      {renderButton('college-tagging-card-button')}
    </div>
  );
};

export default CollegeTaggingCard;
